import type { AnalyticsData } from './types.tsx';

// set

export const SET = 'analytics.SET' as const;
// eslint-disable-next-line jira/export/restrict-types-re-export
export type SetPayload = AnalyticsData;
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});
